import { Link, createFileRoute, useRouteContext } from "@tanstack/react-router";
import {
  OAuthState,
  useProcessOauthToken,
  useSupabase,
  useSupabaseUser,
} from "@repo/lib-web-common";
import { useCallback, useEffect, useState } from "react";

import React from "react";
import { graphql } from "@repo/lib-web-gql";
import { useMutation } from "urql";
import { useNavigate } from "@tanstack/react-router";

const SetTokenDocument = graphql(`
  mutation SetOauthRefreshToken($input: SaveRefreshTokenInput!) {
    saveRefreshToken(input: $input)
  }
`);
export const Route = createFileRoute("/callbacks/auth/google")({
  component: OAuthCallback,
  beforeLoad: ({ context }) => {
    const params = new URLSearchParams(window.location.hash.substring(1));
    context = {
      ...context,
      params: Object.fromEntries(params.entries()),
    };
    console.log(
      "🚀 - file: google.tsx:13 - Route - context:",
      context,
      window.location.hash
    );
    return context;
  },
});

// type TokenProcessError = Error & {
//   code: "UNAUTHENTICATED" | "NO_TOKEN" | "SAVE_FAILED";
// };

function useOAuthCallback() {
  const navigate = useNavigate();
  const supabase = useSupabase();
  const user = useSupabaseUser();
  const [state, setState] = useState<OAuthState>({ status: "idle" });
  const [isProcessing, setIsProcessing] = useState(false);
  const [_, mutate] = useMutation(SetTokenDocument);
  React.useEffect(() => {
    supabase.auth.getSession().then((session) => {
      console.log(
        "🚀 - file: google.tsx:45 - React.useEffect - session:",
        session
      );
    });
  }, []);

  // const createTokenError = useCallback(
  //   (code: TokenProcessError["code"], message: string): TokenProcessError => {
  //     const error = new Error(message) as TokenProcessError;
  //     error.code = code;
  //     return error;
  //   },
  //   []
  // );

  const processOAuthToken = useProcessOauthToken();
  const handleOAuthRedirect = useCallback(
    async (profileId: string) => {
      console.log("🚀 -handleOAuthRedirect profileId:145", profileId);
      setIsProcessing(true);
      try {
        await processOAuthToken(profileId, setState, async (v) => {
          mutate({
            input: {
              provider: "GOOGLE",
              providerAccessToken: v.provider_access_token,
              providerAccessTokenExpiresAt: v.provider_access_token_expires_at,
              providerRefreshToken: v.provider_refresh_token,
              profileId: user.user?.id ?? "",
            },
          });
        });
        console.log("🚀 - profileId:150", profileId);
        if (state.status === "success") {
          console.log("OAuth process completed successfully:", state);
          navigate({ to: "/dashboard" });
        }
      } finally {
        setIsProcessing(false);
      }
    },
    [processOAuthToken, state.status]
  );

  return {
    state,
    isProcessing,
    handleOAuthRedirect,
  };
}

function OAuthCallback(): React.JSX.Element {
  const { state, isProcessing, handleOAuthRedirect } = useOAuthCallback();

  const { user } = useSupabaseUser();
  const st = useRouteContext({ from: Route.fullPath });

  useEffect(() => {
    console.log("Processing OAuth callback:", st);
    if (!user) return;
    handleOAuthRedirect(user.id);
  }, [handleOAuthRedirect, user?.id]);

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center">
        <h1 className="text-xl font-semibold mb-2">
          {isProcessing ? "Processing..." : "Completing Authentication"}
        </h1>
        <p className="text-gray-600">
          {state.status === "processing" && "Saving your credentials..."}
          {state.status === "idle" && "Starting authentication process..."}
          {state.status === "success" && "Authentication successful!"}
          {state.status === "error" && (
            <span className="text-red-600">
              {state.error || "An error occurred"}
            </span>
          )}
        </p>
        <p>
          <Link to={"/sign-in"}>sign-in</Link>
        </p>
      </div>
    </div>
  );
}
